export default __webpack_public_path__ + "static/media/auth-app-native-image.e60ac135.png";